import { getApiRequest } from 'api';

interface IOnlineLessonLink {
    link?: string;
    url?: string;
    block?: boolean;
}

export const onlineLessonsProvider = {
    getOnlineLessonLink: (url: string): Promise<IOnlineLessonLink> => {
        return getApiRequest(url);
    },
};
